export default __webpack_public_path__ + "static/media/full-screen.5febe608.svg";